export const DEFAULT_MODULE = 'landings';

